import logo from './logo.svg';
import './App.css';
import {BrowserRouter, Routes, Route} from 'react-router-dom'
import Index from './components/Index/Index';
import Hosting from './components/Hosting/Hosting';
import Contact from './components/Contact/Contact';
import Faq from './components/Faq/Faq';
import About from './components/About/About';
import Auth from './components/Auth/Auth';
import ShopContainer from './components/Shop/ShopContainer';
import ProductDetails from './components/Shop/ProductDetails/ProductDetails';
import Aboutus from './components/About/Aboutus';
import BulkOrder from './components/Bulkorder/BulkOrder';
import Resale from './components/ResalePolicy/Resale';
import Purchase from './components/PurchasePolicy/Purchase';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Index/>}/>
          <Route path='/hosting' element={<Hosting/>}/>
          <Route path='/contact' element={<Contact/>}/>
          <Route path='/faq' element={<Faq/>}/>
          <Route path='/about' element={<About/>}/>
          <Route path='/aboutus' element={<Aboutus/>}/>
          <Route path='/shop' element={<ShopContainer/>}/>
          <Route path='/productDetails/:id' element={<ProductDetails/>}/>
          <Route path='/bulk-order' element={<BulkOrder/>}/>
          <Route path='/purchase' element={<Purchase/>}/>
          <Route path='/resale' element={<Resale/>}/>
          <Route path='/getstarted' element={<Auth/>}/>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
